import * as React from "react";

function ChatCheckOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "ChatCheckOutline-ChatCheckOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ChatCheckOutline-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ChatCheckOutline-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,5 C35.0454654,5 44,13.5065417 44,23.9999335 C44,34.4933254 35.0454654,43.000129 24,43.000129 C20.5361038,43.0086689 17.1256565,42.1499296 14.0827434,40.5027329 L9.12272737,42.6506288 C8.20180797,43.0490167 7.13075643,42.6289802 6.73046083,41.7124519 C6.57362597,41.3533578 6.53805635,40.953324 6.6290919,40.5723965 L7.89727419,35.2705244 C5.44727043,32.1174388 4,28.2188348 4,23.999959 C4,13.5065671 12.9545346,5 24,5 Z M24.0000207,7.7142478 C14.4327303,7.7142478 6.7272871,15.0337886 6.7272871,23.9999335 C6.7272871,27.3746822 7.816377,30.5920198 9.81910787,33.2999345 L10.0545624,33.6102666 L10.851834,34.636263 L9.70274404,39.4387082 L14.2191094,37.4844293 L15.3900175,38.1213809 C17.9854744,39.5319012 20.9309429,40.2855624 24.0000207,40.2855624 C33.5672971,40.2855624 41.2727403,32.9660501 41.2727403,23.9999051 C41.2727403,15.0337601 33.5672971,7.7142478 24.0000207,7.7142478 Z M33.7782857,18 C33.9991996,18 34.1782857,18.1790861 34.1782857,18.4 C34.1782857,18.5060895 34.1361407,18.6078336 34.0611225,18.6828487 L23.4645144,29.2790094 C22.878728,29.8647958 21.9289805,29.8647958 21.3431941,29.2790094 L21.2662305,29.1971084 C21.1568964,29.1333873 21.0538947,29.0546811 20.9602034,28.9609899 L15.682734,23.6828241 C15.5265346,23.526604 15.5265513,23.273338 15.6827713,23.1171386 C15.7577843,23.0421355 15.8595179,23 15.9655953,23 L19.0763284,23 C19.1824068,23 19.2841412,23.0421363 19.3591544,23.1171406 L22.3713687,26.129 L30.3838446,18.1171463 C30.4588583,18.0421385 30.5605951,18 30.6666763,18 L33.7782857,18 Z",
    id: "ChatCheckOutline-\u5F62\u72B6\u7ED3\u5408",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default ChatCheckOutline;